<div class="login-container">
  <h1 class="display-h2">{{ 'login.welcome-back' | translate }}</h1>
  <h2 class="display-h4 mb-4">{{ 'login.happy-to' | translate }}</h2>

  <app-bankid-button [type]="bankIdTypeEnum.login" class="mt-4 block"></app-bankid-button>

  <div class="w-full flex flex-nowrap items-center justify-center gap-3 mb-[20px]">
    <div class="block w-auto flex-1 h-[1px] bg-cm-grey-100">&nbsp;</div>
    <span class="text-cm-grey-300 text-[14px] flex-none" translate>login.page-separation-or</span>
    <div class="block w-auto flex-1 h-[1px] bg-cm-grey-100">&nbsp;</div>
  </div>

  <form [formGroup]="formGroup" class="mb-4">
    <fieldset>
      <p class="cm-paragraph cm-form-paragraph">
        <app-email [size]="'small'" [parent]="formGroup"></app-email>
      </p>
      <p class="cm-paragraph cm-form-paragraph flex flex-col">
        <app-password [size]="'small'" id="password" [parent]="formGroup"></app-password>
        <a
          class="cm-paragraph-address self-end mt-2 text-16px"
          target="_self"
          [routerLink]="['/reset-password' | localize]"
        >
          {{ 'login.forgot-password' | translate }}
        </a>
      </p>
      <p class="cm-security cm-paragraph cm-form-paragraph">
        <svg-icon class="cm-security-icon" src="/assets/icons/icon-shield.svg"></svg-icon>
        <span>{{ 'login.please-check-visiting' | translate }}</span>
      </p>
      <app-action-button
        type="submit"
        [testId]="'btn-login'"
        [facet]="'primary'"
        [disabled]="formGroup.invalid"
        (action)="login()"
        [isFullWidth]="true"
        [size]="'small'"
        label="shared.common.log-in"
        [waiting]="waiting"
      ></app-action-button>
    </fieldset>
  </form>

  <div class="mt-6">
    <app-action-button
      type="submit"
      [facet]="'tertiary'"
      class="btn-trezor"
      (click)="trezorLogin()"
      [isFullWidth]="true"
      [size]="'small'"
      label="shared.common.log-in-trezor"
    >
      <svg-icon src="/assets/icons/icon-trezor.svg" button-icon-left></svg-icon>
    </app-action-button>
  </div>

  <div class="flex mt-6 items-center justify-center">
    <app-link-pair
      label="{{ 'login.no-account' | translate }}"
      routerLink="/sign-up"
      addressLabel="{{ 'shared.common.signup' | translate }}"
      addressIcon="/assets/img/arrow-right-blue.svg"
      [openInNewWindow]="false"
      [appearance]="'text-[14px]'"
    >
    </app-link-pair>
  </div>
</div>
